import * as React from "react";

function SvgGoogleAd(props) {
  return (
    <svg
      width="2em"
      height="2em"
      viewBox="0 0 48 48"
      fill="currentColor"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          d="M42.397 42.396c-2.314 2.432-5.407 3.912-9.279 4.44-2.717.556-5.831.788-9.343.694-3.512.094-6.626-.138-9.343-.695-3.872-.527-6.965-2.007-9.278-4.439-2.432-2.314-3.911-5.406-4.44-9.278-.556-2.717-.787-5.831-.694-9.343-.093-3.512.138-6.626.695-9.343.528-3.872 2.007-6.965 4.439-9.278 2.313-2.432 5.406-3.912 9.278-4.44 2.717-.556 5.831-.787 9.343-.694 3.512-.093 6.626.138 9.343.695 3.872.527 6.965 2.007 9.279 4.439 2.43 2.313 3.91 5.406 4.438 9.278.557 2.717.789 5.831.695 9.343.094 3.512-.138 6.626-.695 9.343-.527 3.872-2.007 6.964-4.438 9.278z"
        />
        <g fillRule="nonzero" transform="translate(6 7.5)">
          <path
            fill="#FBBC04"
            d="M.743 24.014L12.71 3.285l10.369 5.987-11.965 20.729z"
          />
          <path
            fill="#4285F4"
            d="M35.147 23.942L23.172 3.205a5.987 5.987 0 10-10.369 5.974l11.974 20.737a5.989 5.989 0 0010.45-5.85l-.08-.138v.014z"
          />
          <circle cx={5.987} cy={26.961} r={5.987} fill="#34A853" />
        </g>
      </g>
    </svg>
  );
}

export default SvgGoogleAd;
